<!-- views/MainLayout.vue -->
<template>
  <div class="main-layout">
    <vxe-layout-container vertical>
      <vxe-layout-header class="layout-header">
        <div class="logo">科创电脑经营部</div>
        <div class="user-info">
          <vxe-button mode="text" @click="handleLogout">退出登录</vxe-button>
        </div>
      </vxe-layout-header>

      <vxe-layout-container>
        <vxe-layout-aside :collapsed="!showLeftAside" width="180px">
          <div style="display: flex;flex-direction: column;height: 100%;">
          <vxe-icon name="menu-fold" @click="toggleLeftAside"></vxe-icon>
          <vxe-menu v-model="selectNav" :options="navList" @click="clickEvent"  class="custom-menu"></vxe-menu>
        </div>
        </vxe-layout-aside>

        <vxe-layout-container vertical>
          <vxe-layout-body class="layout-body">
            <!-- 标签页栏 -->
          
             <vxe-tabs v-model="activeTabName" class="full-tabs">
              <vxe-tab-pane v-for="tab in tabsList" :key="tab.ID" :name="tab.ID" :title="tab.title"
                style="background-color: aquamarine;">
                <template #title-suffix>
                  <vxe-button mode="text" style="padding: 0;" icon="vxe-icon-close" size="mini"
                    @click.stop="handleTabRemove(tab.ID)"></vxe-button>
                </template>

                <template #default>
                  <div class="tab-content">
                    <component :is="tab.component" :key="tab.ID" v-bind="tab.props" />
                  </div>
                </template>
              </vxe-tab-pane>
            </vxe-tabs>
          </vxe-layout-body>

          
        </vxe-layout-container>
      </vxe-layout-container>
    </vxe-layout-container>
  </div>

</template>

<script setup>
import { ref, computed ,markRaw } from 'vue'
import { useTabsStore } from '@/pinia/index'
import { useRouter } from 'vue-router'
import salesOut from '@/views/saleoutView.vue'
import SaleoutView from '@/views/saleoutlistview.vue'
import CustomerComp from '@/components/baseinfo/CustomerComp.vue'
import SupplierComp from '@/components/baseinfo/SupplierComp.vue'
import ProductComp from '@/components/baseinfo/ProductComp.vue'
import BuyIn from '@/views/BuyInView.vue'
import SalesReconciliation from '@/views/SalesReconciliation.vue'
import SalesAnalysis from '@/views/SalesAnalysis.vue'
import PCBuildOrderList from '@/views/PCBuildOrderListView.vue'
import {CreateNewDocument,CeatrandomUUID} from '@/utils/saleDocHelper.js'
import addPCBuildComp from '@/components/addComp/addPCBuildComp.vue'
import BuyInList from '@/views/Buylistview.vue'

const showLeftAside = ref(true)
const toggleLeftAside = () => {
  showLeftAside.value = !showLeftAside.value
}

// 菜单数据
const selectNav = ref('')
const navList = ref([
  { name: 'home', title: '首页', icon: 'vxe-icon-lock' },
  {
    name: 'baseinfo',
    title: '基本资料',
    icon: 'vxe-icon-copy',
    children: [{ name: 'CustomerInfo', title: '客户资料', icon: 'vxe-icon-add-user' },
    { name: 'SupplierInfo', title: '供货商资料', icon: 'vxe-icon-user' },
    { name: 'ProductInfo', title: '商品资料', icon: 'vxe-icon-goods' }
    ]
  },
  {
    name: 'sales',
    title: '销售管理',
    icon: 'vxe-icon-menu-unfold',
    children: [
      {
        name: 'SalesOut',
        title: '销售出库单',
        icon: 'vxe-icon-chart-line'
      },
      {
        name: 'SalesOutQuery',
        title: '销售出库查询',
        icon: 'vxe-icon-search'
      },
      {
        name: 'SalesCheck',
        title: '销售对账',
        icon: 'vxe-icon-merge-cells'
      },
      {
        name: 'SalesAnalysis',
        title: '销售分析',
        icon: 'vxe-icon-chart-pie'
      },
      {
        name: 'SalesContract',
        title: '销售合同',
        icon: 'vxe-icon-file-word'
      },
    ]
  },
  {
    name: 'buy',
    title: '采购管理',
    icon: 'vxe-icon-more',
    children: [
      {
        name: 'BuyIn',
        title: '采购入库单',

      },
      {
        name: 'BuyInQuery',
        title: '采购出库查询',
      },

    ]
  },
  {
    name: 'InstallationOrder',
    icon: 'vxe-icon-custom-column',
    title: '装机单管理',
    children: [
      {
        name: 'AddInstallationOrder',
        title: '新建装机单',

      },
      {
        name: 'InstallationOrderQuery',
        title: '装机单查询',
      },

    ]
  },
  {
    name: 'database',
    title: '数据库管理',
    // 使用 prefixConfig 传入自定义图标组件
    icon: 'vxe-icon-table',
    children: [
      { name: 'databasemanagement', title: '数据库管理' },
    ]
  }
])
const clickEvent = () => {
  // 根据菜单项配置标签页
  const tabMap = {
   
    'SalesOut': {
      name: 'SalesOut',
      title: '销售出库单',
      ID: CeatrandomUUID(),
      closable:true,
      component: markRaw(salesOut),
      props: {
      initialData: { 
        usefule: '新增', 
        docNumber: CreateNewDocument('XSDH') 
      }
    }
    },
     'SalesOutQuery': {
      name: 'SalesOutQuery',
      title: '销售出库查询',
      ID: CeatrandomUUID(),
      closable:true,
      component:markRaw(SaleoutView),
      props: {
      initialData: { 
        usefule: '新增', 
        docNumber: CreateNewDocument('XSDH') 
      }
    }
    },
     'CustomerInfo': {
      name: CeatrandomUUID(),
      title: '客户资料',
      ID: CeatrandomUUID(),
      closable:true,
      component:markRaw(CustomerComp),
     
    },
    'SupplierInfo': {
      name: CeatrandomUUID(),
      title: '供货商资料',
      ID: CeatrandomUUID(),
      closable:true,
      component:markRaw(SupplierComp),
    },
    'ProductInfo': {
      name: CeatrandomUUID(),
      title: '产品资料',
      ID: CeatrandomUUID(),
      closable:true,
      component:markRaw(ProductComp),
    },
    'BuyInQuery': {
      name: CeatrandomUUID(),
      title: '采购入库查询',
      ID: CeatrandomUUID(),
      closable:true,
      component:markRaw(BuyInList),
    },
     'BuyIn': {
      name: CeatrandomUUID(),
      title: '采购入库单',
      ID: CeatrandomUUID(),
      closable: true,
      component: markRaw(BuyIn),
      props: {
        initialData: {
          usefule: '新增',
          docNumber: CreateNewDocument('RKDH')
        }
      }
    },
    'SalesCheck': {
      name: CeatrandomUUID(),
      title: '销售对账',
      ID: CeatrandomUUID(),
      closable:true,
      component:markRaw(SalesReconciliation),
    },
    'SalesAnalysis': {
      name: CeatrandomUUID(),
      title: '销售分析',
      ID: CeatrandomUUID(),
      closable:true,
      component:markRaw(SalesAnalysis),
    },
    'InstallationOrderQuery': {
      name: CeatrandomUUID(),
      title: '装机单列表',
      ID: CeatrandomUUID(),
      closable:true,
      component:markRaw(PCBuildOrderList),
    },
    'AddInstallationOrder': {
      name: CeatrandomUUID(),
      title: '装机单',
      ID: CeatrandomUUID(),
      closable:true,
      component:markRaw(addPCBuildComp),
      props: {
        initialData: {
          usefule: '新增',
          docNumber: CreateNewDocument('ZJD')
        }
      }
    },
  }
  const tabConfig = tabMap[selectNav.value]
  if (tabConfig) {

    // 添加标签页（如果已存在会自动切换到该标签页）
   const tabsStore = useTabsStore()
  tabsStore.addTab(tabConfig, true)
  }
}


// 同步 Store 中的标签状态
const tabsList = computed(() => useTabsStore().tabs)
const activeTabName = computed({
  get: () => useTabsStore().activeTab,
  set: (val) => { useTabsStore().activeTab = val }
})

// 移除标签
const handleTabRemove = (tabId) => {
  const tabsStore = useTabsStore()
  const tabIndex = tabsStore.tabs.findIndex(tab => tab.ID === tabId)
  if (tabIndex === -1) return

  const tab = tabsStore.tabs[tabIndex]
  if (tab.closable === false) return

  // 先记录是否是当前激活
  const wasActive = tabsStore.activeTab === tabId

  // 直接删除
  tabsStore.tabs.splice(tabIndex, 1)

  // 只有删的是当前激活项时，才需要切换
  if (wasActive) {
    if (tabsStore.tabs.length === 0) {
      tabsStore.activeTab = ''
    } else if (tabIndex < tabsStore.tabs.length) {
      tabsStore.activeTab = tabsStore.tabs[tabIndex].ID      // 下一个
    } else {
      tabsStore.activeTab = tabsStore.tabs[tabIndex - 1].ID  // 上一个
    }
  }
}
// 退出登录
const handleLogout = () => {
  useTabsStore().logout()
  useRouter().push('/login')
}
</script>

<style scoped>
.main-layout {
  height: 100vh;

}

.layout-header {
  height: 40px;
  background-color: #fff;
  border-bottom: 1px solid #dcdfe6;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0, 21, 41, .08);
}

.logo {
  font-size: 18px;
  font-weight: bold;
  color: #409eff;
}
/* 让 vxe-layout-body 占满剩余高度 */
.layout-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 让 vxe-tabs 占满整个父容器 */
.full-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.tab-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

:deep(.vxe-tabs--body-wrapper),
:deep(.vxe-tabs--body),
:deep(.vxe-tabs--pane) {
  min-height: 0;
}

:deep(.vxe-tabs--body-wrapper),
:deep(.vxe-tabs--pane) {
  height: 100%;
}

.custom-menu {
  flex: 1;

}

/* 或者通过深度选择器 */
:deep(.vxe-menu) {
  background-color: #545C64 ;
}
:deep(.vxe-menu--item-link-title)
{
  color: #ffffff;
  
}
:deep(.vxe-menu--item-link-icon){
    color: #fff;
    margin-right: 6px;
  }
/* 或者使用深度选择器 */
:deep(.vxe-menu) {
  --vxe-ui-base-active-background-color: #0e0af0 !important;
}
</style>